import FreeAccountList from '@containers/account/FreeAccountList';

const FreeAccountListPage = () => {
  return <FreeAccountList />;
};

export default FreeAccountListPage;
